import { Component, OnInit, OnDestroy } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers/index';

import * as fromKeywords from './../store/keywords.actions';
import { Keyword } from '../models/keywords.model';
import { Subscription, Observable } from 'rxjs';
import { getKeywords, getIsLoading } from '../store/keywords.selectors';
import { take, map } from 'rxjs/operators';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { KeywordsModalComponent } from '../../shared/components/keywords-modal/keywords-modal.component';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-keywords',
  templateUrl: './keywords.component.html',
  styleUrls: ['./keywords.component.scss']
})
export class KeywordsComponent implements OnInit, OnDestroy {
  isLoading$: Observable<boolean>;
  keywords: Keyword[] | null;
  modalRef: MDBModalRef;

  keywordsSub: Subscription;

  modalConfig = {
    class: 'modal-dialog-centered'
  };

  lastKeywordIndex: number;
  allKeywordIndex: number; 

  constructor(private modalService: MDBModalService, private store: Store<AppState>, private afAuth: AngularFireAuth) { }

  ngOnInit() {
    this.isLoading$ = this.store.select(getIsLoading);

    this.keywordsSub = this.store.select(getKeywords).pipe(
      map( (keywords: Keyword[]) => {
        if (this.user && !keywords) {
          this.store.dispatch(new fromKeywords.KeywordsQuery());
        }
        return keywords;
      })
    )
    .subscribe( (keywords: Keyword[]) => {
      if (keywords && keywords.length !== 0) {
        const index: number = Number(keywords[keywords.length - 1].id);
        const indexSub: number = Number([keywords.length]);
        
        
        this.lastKeywordIndex = index;
        this.allKeywordIndex = indexSub;
        // for (let i = 1; i <= this.allKeywordIndex; i++) {
        //   const changeId = i - 1
        //   const pushNew = {
            
        //     id: changeId
        //   }
          
          
    
          
          
         
          
        //   console.log (changeId, pushNew);
    
          
            
        //     this.store.dispatch(new fromKeywords.KeywordsEdited({ keyword: pushNew }));
            
          
        // }
        
      } else {
        this.lastKeywordIndex = 0;
        this.allKeywordIndex = 0; 
      }

      this.keywords = keywords;
    });
  }

  get user() {
    return this.afAuth.auth.currentUser;
  }

  ngOnDestroy() {
    if (this.keywordsSub) {
      this.keywordsSub.unsubscribe();
    }
  }

  onAddKeyword() {
    this.modalRef = this.modalService.show(KeywordsModalComponent, this.modalConfig);

    this.modalRef.content.heading = 'Add new keyword';
    this.modalRef.content.keyword.id = this.lastKeywordIndex + 1;

    this.modalRef.content.keywordData.pipe(take(1)).subscribe( (keywordData: Keyword) => {
      this.store.dispatch(new fromKeywords.KeywordsAdded({ keyword: keywordData }));
    });
  }

  onSubtractKeyword(keyword: Keyword) {
    
    for (let i = 1; i <= this.allKeywordIndex; i++) {
      const changeId = i - 1
      const pushNew = {
        key: keyword.key,
        id: changeId
      }
      
      keyword = pushNew

      
      
     
      
      console.log (changeId, pushNew);

      this.store.dispatch(new fromKeywords.KeywordsEdited({ keyword: keyword }));
    }
    
    
    
  }

  openEditKeywordModal(keyword: Keyword) {
    this.modalRef = this.modalService.show(KeywordsModalComponent, this.modalConfig);

    this.modalRef.content.heading = 'Edit keyword';
    const keywordCopy = {
      key: keyword.key,
      id: keyword.id || keyword.id,
      name: keyword.name || keyword.name,
      exclude: keyword.exclude || keyword.exclude,
      description: keyword.description || keyword.description
     };
    this.modalRef.content.keyword = keywordCopy;

    this.modalRef.content.keywordData.pipe(take(1)).subscribe( (keywordData: Keyword) => {
      this.store.dispatch(new fromKeywords.KeywordsEdited({ keyword: keywordData }));
    });
  }

  openConfirmModal(keyword: Keyword) {
    this.modalRef = this.modalService.show(ConfirmModalComponent, this.modalConfig);
    

    this.modalRef.content.confirmation.pipe(take(1)).subscribe( (confirmation: boolean) => {
      if (confirmation) {
        this.store.dispatch(new fromKeywords.KeywordsDeleted({ keyword }));
      }
    });

    
  
      
    
    
  }

  onKeywordEdit(keyword: Keyword) {
    this.openEditKeywordModal(keyword);
  }

  onKeywordDelete(keyword: Keyword) {
    this.openConfirmModal(keyword);
    
    
    
  }

}
